import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../redux/cartSlice';
import plants from '../data/plants';
import './ProductListingPage.css';

function ProductListingPage() {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.items);
  const [disabledButtons, setDisabledButtons] = useState({});

  // Group plants by category
  const groupedPlants = plants.reduce((groups, plant) => {
    (groups[plant.category] = groups[plant.category] || []).push(plant);
    return groups;
  }, {});

  const handleAddToCart = (plant) => {
    dispatch(addToCart(plant));
    setDisabledButtons((prev) => ({ ...prev, [plant.id]: true }));
  };

  return (
    <div className="product-listing">
      {Object.entries(groupedPlants).map(([category, plants]) => (
        <section key={category}>
          <h2>{category}</h2>
          <div className="plant-grid">
            {plants.map((plant) => (
              <div key={plant.id} className="plant-card">
                <img src={plant.thumbnail} alt={plant.name} />
                <h3>{plant.name}</h3>
                <p>${plant.price.toFixed(2)}</p>
                <button
                  onClick={() => handleAddToCart(plant)}
                  disabled={disabledButtons[plant.id] || cartItems[plant.id]}
                >
                  {disabledButtons[plant.id] || cartItems[plant.id]
                    ? 'Added'
                    : 'Add to Cart'}
                </button>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

export default ProductListingPage;
